import type { Client } from "urql";

import { TanStackDevtools } from "@tanstack/react-devtools";
import { formDevtoolsPlugin } from "@tanstack/react-form-devtools";
import {
  ErrorComponent,
  HeadContent,
  Outlet,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import type { AuthContextType } from "@/context/auth-provider";

import { NavigationProgress } from "@/components/navigation-progress";
import { TanstackNotfoundComponent } from "@/components/tanstack-notfound-component";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

interface RouterContext {
  urqlClient: Client;
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  errorComponent: ({ error }) => <ErrorComponent error={error} />,
  notFoundComponent: ({ routeId }) => "Root NotFound: " + routeId,
  component: () => {
    return (
      <>
        <HeadContent />
        <NavigationProgress />
        <TooltipProvider>
          <Outlet />
        </TooltipProvider>
        <Toaster closeButton expand={false} richColors />
        {__NODE_ENV__ === "development" && (
          <TanStackDevtools
            config={{
              position: "bottom-right",
            }}
            plugins={[
              {
                name: "Tanstack Router",
                render: <TanStackRouterDevtoolsPanel />,
              },
              formDevtoolsPlugin(),
            ]}
          />
        )}
      </>
    );
  },
  head: () => ({
    meta: [
      {
        title: "See It Send It",
      },
    ],
  }),
});
